angular.module('impactx.invoice').controller('InvoiceListSupplierCtrl', [
    'dataGen',
    'selectedListItems',
    '$route',
    'DownloadService',
    '$mdDialog',
    '$redirect',
    'InvoiceDialogService',
    'ixaInvoiceActions',
    'ToastService',
    'TranslationService',
    'ConfirmationService',
    InvoiceListSupplierCtrl]);

function InvoiceListSupplierCtrl(dataGen, selectedListItems, $route, DownloadService, $mdDialog, $redirect, InvoiceDialogService,
                                 ixaInvoiceActions, ToastService, TranslationService, ConfirmationService) {
    this.createInvoice = function (event, actionLabel, trns, additionalFields) {
        $mdDialog.show({
            controller: "InvoiceCreationCtrl",
            controllerAs: "invoiceCreationCtrl",
            templateUrl: "modules/invoice/templates/invoicecreation.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                actionLabel: actionLabel,
                withOrderRefLabel: trns.withOrderRef,
                noOrderRefLabel: trns.noOrderRef,
                lotLabel: trns.lot,
                orderLabel: trns.order,
                forwardLabel: trns.forward,
                abortLabel: trns.abort,
                confirmLabel: trns.confirm,
                requiredLabel: trns.required,
                noSelectedItemMessage: trns.noSelectedItemMessage,
                invoiceReceiverLabel: trns.invoiceReceiver,
                orderTemplate: additionalFields.orderTemplate,
                creditNote: false,
                preSetPoh: null
            }
        })
            .then(function (answer) {
                if (answer.deliveryDateValue) {
                    $redirect.redirectTo(null, "invoiceview/0/" + answer.lotSupplierId + "/" + answer.pohId + "/" +
                        answer.orderComId + "/" + answer.deliveryDateValue + "/" + new Date().getTime())
                }
                else {
                    $redirect.redirectTo(null, "invoiceview/0/" + answer.lotSupplierId + "/" + answer.pohId + "/" +
                        answer.orderComId + "/" + new Date().getTime())
                }
            }, function () {
            });
    };

    function redirectToDetails($event) {
        dataGen.postAsForm({}, {blhId: selectedListItems.getFirstSelectedId()}, "/invoice/checkstatusforedit").then(function (response) {
            if (impactX.isDefined(response, 'data.showWarning')) {
                ConfirmationService.showHTMLConfirmationDialog(
                    function() {
                        $redirect.redirectTo(null, "invoiceview/" + selectedListItems.getFirstSelectedId());
                    },
                    $event,
                    TranslationService.get('warning'),
                    TranslationService.get('ok'),
                    TranslationService.get('abort'),
                    response.data.warning,
                    null
                );
            }
            else {
                $redirect.redirectTo(null, "invoiceview/" + selectedListItems.getFirstSelectedId());
            }
        });
    }

    var buttonDefinition = [
        {
            label: "details",
            action: redirectToDetails,
            condition: selectedListItems.isSingleSelection,
            process: 'ViewInvoice'
        },
        {
            label: "downloadPDF",
            action: downloadPDF,
            condition: function () {
                return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDownloadPDF;
            }
        },
        {
            label: "downloadXML",
            action: downloadXML,
            condition: function () {
                return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDownloadXML;
            }
        },
        {
            label: "creditNote",
            action: createCreditNoteForInvoice,
            condition: function () {
                return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCreateCreditNote.value;
            },
            process: 'EditInvoice'
        },
        {
            label: "creditNote",
            action: createCreditNote,
            condition: selectedListItems.isNoSelection,
            process: 'EditInvoice'
        },
        {
            label: "deactivate",
            action: deactivate,
            condition: function () {
                return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDeactivate;
            },
            process: "EditInvoice"
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/invoice/templates/invoicelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/invoice/listsupplier',
        id: "invoicelistsupplier",
        mainActionFunction: {id: "new", action: this.createInvoice, icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function createCreditNoteForInvoice() {
        dataGen.getData({}, {blhId: selectedListItems.getFirstSelectedId()}, "/invoice/creditnotepossible").then(function (response) {
            if (response.data.canCreateCreditNote) {
                $redirect.redirectTo(null, "creditnoteforinvoice/" + selectedListItems.getFirstSelectedId() + "/true");
            }
            else if (response.data.needContract) {
                ixaInvoiceActions.openContractSelectionDialog(response).then(function (result) {
                    if (result) {
                        ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                        $redirect.redirectTo(null, "creditnoteforinvoice/" + selectedListItems.getFirstSelectedId() + "/true");
                    }
                });
            }
        });
    }

    function createCreditNote(event, trns, additionalFields) {
        $mdDialog.show({
            controller: "InvoiceCreationCtrl",
            controllerAs: "invoiceCreationCtrl",
            templateUrl: "modules/invoice/templates/invoicecreation.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                actionLabel: trns.creditNote,
                withOrderRefLabel: trns.withOrderRef,
                noOrderRefLabel: trns.noOrderRef,
                lotLabel: trns.lot,
                orderLabel: trns.order,
                forwardLabel: trns.forward,
                abortLabel: trns.abort,
                confirmLabel: trns.confirm,
                requiredLabel: trns.required,
                noSelectedItemMessage: trns.noSelectedItemMessage,
                invoiceReceiverLabel: trns.creditNoteReceiver,
                orderTemplate: additionalFields.orderTemplate,
                creditNote: true,
                preSetPoh: null
            }
        }).then(function (answer) {
            if (answer.deliveryDateValue) {
                $redirect.redirectTo(null, "creditnote/0/true/" + answer.lotSupplierId + "/" + answer.orderComId + "/" + answer.deliveryDateValue)
            }
            else {
                $redirect.redirectTo(null, "creditnote/0/true/" + answer.lotSupplierId + "/" + answer.orderComId)
            }
        });
    }

    function deactivate(event, trns) {
        InvoiceDialogService.deactivate(event, selectedListItems.getFirstSelectedId(), trns.deactivateMessage, trns.saveSuccess, true);
    }

    function downloadPDF() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        DownloadService.openDownloadPost('/invoice/download/pdf', {paramName: "id", paramValue: selectedItem.invoiceInfoId});
    }

    function downloadXML() {
        var selectedItem = selectedListItems.getFirstSelectedItem();
        DownloadService.openDownloadPost('/invoice/download/xml', {paramName: "id", paramValue: selectedItem.invoiceInfoId});
    }
}